function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfobookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1154_5166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9989 4.21503V21.2723H21.9849C20.6978 21.2723 18.9559 19.5189 17.6379 19.1052C16.2046 18.656 14.2123 18.7337 12.8853 19.4572C12.6075 19.6092 12.2509 20.0059 11.9629 19.9853C11.7285 19.9693 10.9124 19.3235 10.5409 19.1726C9.34305 18.6868 7.24446 18.7565 6.04086 19.2115C4.83726 19.6664 3.21989 21.27 2.014 21.27H0V4.21275H1.6711C2.64723 4.21275 4.04286 3.17146 4.94013 2.76797C7.40677 1.6581 9.54765 1.77697 11.956 2.97828C14.1037 2.00786 15.8354 1.6501 18.1317 2.4102C19.3365 2.80912 21.219 4.21275 22.3289 4.21275H24L23.9989 4.21503ZM11.5697 18.7863V3.74297C9.54879 2.57137 7.69596 2.49936 5.54708 3.3772C4.51607 3.79897 3.54908 4.57737 2.46664 4.84027C1.89056 4.97971 1.33848 4.95343 0.769252 5.0723V20.5008C2.79354 20.8471 4.05315 19.1749 5.68196 18.5142C7.18503 17.905 9.32933 17.857 10.8415 18.4422C11.1113 18.5462 11.3079 18.704 11.5685 18.7863H11.5697ZM23.2273 5.0723C22.9061 4.93742 22.5724 5.02315 22.2523 4.97629C20.0406 4.6471 18.5341 2.97257 16.2309 2.76911C14.8444 2.64681 13.7002 3.19089 12.4281 3.61495V18.7863C14.0957 17.8353 16.6138 17.7895 18.3729 18.5417C19.7388 19.1257 20.7378 20.3739 22.3289 20.4996C22.6009 20.5214 23.0387 20.5717 23.2273 20.3728V5.0723Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7967 15.0999L19.7842 15.5594L19.6721 15.6783L15.8076 15.6189L15.7676 15.0999L16.6557 15.0885C16.7894 15.0428 16.8374 14.8199 16.8603 14.693C16.9929 13.9638 16.9403 11.9132 16.8855 11.1108C16.834 10.369 16.3642 10.5987 15.7676 10.5576V10.0421C16.4911 10.0512 17.2226 9.91748 17.9279 9.75974C18.1176 9.71745 18.6263 9.44541 18.728 9.61L18.7029 14.6073C18.8217 15.2771 19.2618 15.0816 19.7967 15.0988V15.0999Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4611 6.54898C18.7344 6.28952 19.4248 7.77202 18.316 8.34581C16.7992 9.13107 15.9203 6.86217 17.4611 6.54898Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1154_5166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfobookIcon);
export default __webpack_public_path__ + "static/media/infobook-icon.9cee0059d695085e6ba25e04d9066376.svg";
export { ForwardRef as ReactComponent };